export enum PartnerTiersType {
  BETA = 'BETA',
  BRONZE = 'BRONZE',
  SILVER = 'SILVER',
  GOLD = 'GOLD',
  PLATINUM = 'PLATINUM',
}

export enum PartnerUsageHealthScoreType {
  NA = 'NA',
  POOR = 'POOR',
  HEALTHY = 'HEALTHY',
  EXCEPTIONAL = 'EXCEPTIONAL',
}

export type TierType = {
  key: keyof typeof PartnerTiersType;
  label: string;
  next: any;
  prev: any;
  perks: string[];
};

export type TiersMapType = {
  [key in keyof typeof PartnerTiersType]?: TierType;
};

export type TierNames = {
  [key in keyof typeof PartnerTiersType]?: PartnerTiersType;
};

type Tier = {
  minimum: string;
  percent: number;
  upgrade: string;
};

export type PartnerDashboard = {
  health: {
    currentScore: PartnerUsageHealthScoreType;
    hasCompleted: boolean;
    statistics: {
      bugs: number;
      featureRequests: number;
      issues: number;
      percentResponded: number;
    };
    tier: Tier;
  };
  status: {
    deadline: string;
    tier: PartnerTiersType;
  };
  usage: {
    currentActive: number;
    hasCompleted: boolean;
    tier: Tier;
  };
};

export type Usage = {
  labels: Array<string>;
  values: Array<string>;
};

export type Statistics = {
  quarterly: Usage;
  monthly: Usage;
};
